import { use } from "react";
import { buildApiUrl } from "../../services/apiConfig";
import { v4 as uuidv4 } from 'uuid';

class UserProfileService {

    getOrGenerateThreadID() {
        let threadID = sessionStorage.getItem("wealth_thread_id");
        if (!threadID) {
            threadID = uuidv4();
            sessionStorage.setItem("wealth_thread_id", threadID);
        }
        return threadID;
    }

    async sendMessage(input, files, userId, useCaseId, options = {}) {
        const { returnRawResponse = false } = options;
        const formData = new FormData();
        formData.append("query", input);
        formData.append("cust_id", userId);
        formData.append("advisor_id", userId);
        formData.append("use_case_id", useCaseId);
        formData.append("agent_id", "63493");

        const threadId = this.getOrGenerateThreadID();
        formData.append("thread_id", threadId);

        files.forEach(file => {
            formData.append("files", file);
        });

        const response = await fetch(buildApiUrl('NOVA', '/Nova_chat_stream'), {
            method: "POST",
            body: formData,
        });

        if (!response.ok) {
            throw new Error(`Server responded with ${response.status}`);
        }

        if (returnRawResponse) {
            return response;
        }

        return this.processStreamingResponse(response);
    }

    async processStreamingResponse(response) {
        let accumulatedText = '';

        try {
            const { createParser } = await import('eventsource-parser');

            const parser = createParser({
                onEvent: (event) => {
                    const type = event.event;
                    if (type === "filler" || type === "interrupt" || type === "final") {
                        try {
                            const parsedData = JSON.parse(event.data);

                            if (parsedData.ERROR && typeof parsedData.ERROR === 'string') {
                                throw new Error(parsedData.ERROR);
                            }

                            if (parsedData.data.response) {
                                accumulatedText += parsedData.data.response;
                            } else if (parsedData.data) {
                                accumulatedText += parsedData.data;
                            }
                        } catch (error) {
                            console.error("Error processing event data:", error);
                        }
                    }
                }
            });

            const reader = response.body.getReader();

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;

                const chunk = new TextDecoder().decode(value);
                parser.feed(chunk);
            }

            try {
                return JSON.parse(accumulatedText);
            } catch (parseErr) {
                console.warn("Initial JSON parse failed, attempting to extract JSON:", parseErr.message);
                console.log("Accumulated text:", accumulatedText);
                
                // Try to find JSON object in the accumulated text
                const jsonMatch = accumulatedText.match(/\{[\s\S]*\}/);
                if (jsonMatch) {
                    try {
                        const parsed = JSON.parse(jsonMatch[0]);
                        console.log("Successfully extracted and parsed JSON:", parsed);
                        return parsed;
                    } catch (e) {
                        console.error("Failed to parse extracted JSON:", e);
                        throw new Error("Could not parse response data");
                    }
                } else {
                    console.warn("No JSON object found, returning raw text");
                    return accumulatedText;
                }
            }
        } catch (err) {
            console.error("Error processing streaming response:", err);
            throw new Error("Failed to process response");
        }
    }

    buildApiUrl(service, endpoint) {
        return buildApiUrl(service, endpoint);
    }

}

export default new UserProfileService();